<template>
  <div class="completeness">
    <div class="completeness-bar" v-if="itemsCount != null ">
      <div class="completeness-stats">
        <span class="main-number">{{ completedItemsCount }}<span class="tag-of">{{ $t('checklist.of') }}</span>{{ itemsCount }}</span>
        &nbsp;&nbsp;&nbsp;{{ recordId ? $t('checklist.completeness_tag_short') : $t('checklist.completeness_tag')}}
      </div>
      <div class="progress">
        <div v-if="itemsCount > 0" class="progress-bar bg-success" role="progressbar" :style="{ width: progress }">
          <div class="value-wrapper">{{ progress }} {{ $t('checklist.complete') }}</div>
        </div>

        <div v-if="itemsCount > 0 && progress === '0%'" class="progress-bar bg-neutral" role="progressbar">
          <b>{{ progress }} {{ $t('checklist.complete') }}</b>
        </div>

        <div class="progress-bar empty-checklist" v-if="itemsCount === 0">
          <b>{{ $t('checklist.empty_checklist') }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['itemsCount', 'completedItemsCount', 'recordId'],
    computed: {
      progress() {
        if (this.$props.itemsCount === 0)
          return '0%'

        return (this.$props.completedItemsCount / this.$props.itemsCount * 100).toFixed(1) + '%'
      },
    },
  }
</script>

<style lang="sass" scoped>
  .completeness-bar
    margin-top: 15px
    .completeness-stats
      width: 20%
      height: 40px
      padding: 10px 0
      float: left
      font-size: 12px
      &.full
        display: contents
      .main-number
        font-size: 15px
        font-weight: 500
        .tag-of
          font-size: 12px
          padding: 0 2px

    .progress
      width: 75%
      height: 40px
      text-align: center
      background: #eee
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset
      float: left
      &.full
        width: 100%
        

      .bg-success
        padding-left: 0
        text-shadow: -1px -1px 1px rgba(255,255,255,.1), 1px 1px 1px rgba(0,0,0,.2)
        background: #567AE3!important
        .value-wrapper
          padding-left: 10px
          display: inline-block
          font-weight: 400
          font-family: 'Roboto', sans-serif
          font-size: 14px

      .bg-neutral, .empty-checklist
        width: 100%
        color: #686868
        background: #c4c4c4

  .shared-folders-checklist-status
    .completeness-bar
      .completeness-stats
        font-size: 12px
        font-weight: 400
        height: auto
        float: none
        width: 60%
      .main-number
        font-weight: bold
        font-size: 14px
        .tag-of
          font-size: 12px
      .progress
        height: 20px
        float: none
        .empty-checklist
          color: #686868
          background: #c4c4c4
          width: 100%
          b
            font-size: 12px
            padding: 3px
        .value-wrapper, b
          font-size: 12px
          padding: 3px
        .bg-success
          text-shadow: -1px -1px 1px rgba(255, 255, 255, 0.1), 1px 1px 1px rgba(0, 0, 0, 0.2)
          background: #567AE3 !important
  .shared-folder-status
    .completeness-bar
      .completeness-stats
        font-size: 14px
        .main-number
          span
            padding: 0 3px
      .progress
        height: 40px
  .all-checklists
    .completeness-bar
      display: flex
      .progress
        width: 75%
        height: 40px
        text-align: center
        background: #eee
        -webkit-box-shadow: 0 2px 5px rgba(0,0,0,.25) inset
        box-shadow: inset 0 2px 5px rgba(0,0,0,.25)
        .bg-success
          padding-left: 0
          text-shadow: -1px -1px 1px hsla(0,0%,100%,.1), 1px 1px 1px rgba(0,0,0,.2)
          background: #567ae3!important
          .value-wrapper
            padding-left: 10px
            display: inline-block
            font-weight: 400
            font-family: Roboto,sans-serif
            font-size: 14px
      .completeness-stats
        margin: 10px 10px 0 0
        font-size: 14px
</style>
